export default __webpack_public_path__ + "4fb432f6f7c0b9c4584d550b95c0b1c5.png";